<script setup lang="ts" generic="Value">
import ChatDiagnosisTemplateInputItemLayout from './ChatDiagnosisTemplateInputItemLayout.vue';
import InputCheckboxWithLabelList, {
  type CheckBoxOption,
} from 'theme/components/molecules/InputCheckboxWithLabelList.vue';
import InputHelperText from 'theme/components/molecules/InputHelperText.vue';

const props = withDefaults(
  defineProps<{
    modelValue: Nullable<Value[]>;
    title: string;
    name: string;
    notes?: string[];
    error?: ValidationError;
    options: CheckBoxOption<Value, string>[];
    inactive: boolean;
  }>(),
  {
    notes: () => [],
    error: undefined,
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: Value[]];
}>();

const wrappedModelValue = computed<Value[]>({
  get() {
    return props.modelValue ?? [];
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<script lang="ts">
export type { CheckBoxOption } from 'theme/components/molecules/InputCheckboxWithLabelList.vue';
</script>

<template>
  <ChatDiagnosisTemplateInputItemLayout
    :title="title"
    :inactive="inactive"
    tag="div"
  >
    <template #input>
      <InputHelperText :notes="notes" :error="error">
        <InputCheckboxWithLabelList
          v-model="wrappedModelValue"
          :options="options"
          :name="name"
          wrap
        />
      </InputHelperText>
    </template>
  </ChatDiagnosisTemplateInputItemLayout>
</template>

<style lang="scss" module>
.footer {
  &__item {
    width: 100%;
  }
}
</style>
